import { useWindowDimensions } from 'react-native'
import metrics from 'APP/Themes/Metrics'
import { useMemo } from 'react'

const useScreenView = (): { isSmallScreen: boolean; isBigScreen: boolean } => {
  const dimensions = useWindowDimensions()

  const isSmallScreen = useMemo(() => dimensions.width < metrics.mobileView.max, [dimensions.width])
  const isBigScreen = useMemo(() => dimensions.width >= metrics.tabletView.max, [dimensions.width])

  return {
    isSmallScreen,
    isBigScreen,
  }
}

export default useScreenView
